// extracted by mini-css-extract-plugin
export default {"tooltip":"checkouts_tooltip__vRe8C","buttonsWrapper":"checkouts_buttonsWrapper__8-ujm","button":"checkouts_button__+3CYx","page":"checkouts_page__IQ119"};